import i18next from 'i18next'
import validator from 'validator'
import z from 'zod'

import { ParamsKind } from 'features/globalSetup/pages/Prebid/Bidders/types'
import { MAX_SAFE_GQL_FLOAT, MAX_SAFE_GQL_INTEGER } from 'providers/tanstack-query/constants'
import { CONSTANTS, SchemaAdUnitBidderParamValidation, SchemaAdUnitBidderProps } from './schema'

export const validatedAdUnitBidderParam = ({
  adUnitBidder,
  adUnitBidderId,
  ctx,
  paramKind,
  paramName,
  paramValue,
}: {
  adUnitBidder: SchemaAdUnitBidderProps
  adUnitBidderId: z.infer<typeof CONSTANTS.ID>
  ctx: z.RefinementCtx
  paramKind: ParamsKind
  paramName: z.infer<typeof CONSTANTS.AD_UNIT_BIDDER_PARAM.NAME>
  paramValue: z.infer<typeof CONSTANTS.AD_UNIT_BIDDER_PARAM.VALUE>
}) => {
  if (paramValue === undefined) {
    return
  }

  const rules: SchemaAdUnitBidderParamValidation | undefined = adUnitBidder._paramsValidation.find(
    rule => rule.name === paramName && rule.kind === paramKind,
  )
  if (rules === undefined) {
    throw Error(`Validation rules not found for param ${paramName} of paramKind ${paramKind}.`)
  }

  const addError = (message: string): void => {
    ctx.addIssue({
      code: 'custom',
      message,
      path: ['adUnitBidders', adUnitBidderId, `${paramKind}Params`, paramName],
    })
  }
  const isEmpty: boolean = validator.isEmpty(paramValue, { ignore_whitespace: true })
  const isInteger: boolean = validator.isInt(paramValue)
  const isFloat: boolean = validator.isFloat(paramValue, { locale: 'pl-PL' })
  const isGqlSafe = (safeValue: number): boolean => Number(paramValue) > safeValue

  switch (rules.type) {
    case 'float': {
      if (!isEmpty) {
        if (!isFloat) {
          addError(i18next.t('common:form.error.float'))
        }
        if (isGqlSafe(MAX_SAFE_GQL_FLOAT)) {
          addError(i18next.t('common:form.error.outOfRange'))
        }
      }
      break
    }

    case 'integer': {
      if (!isEmpty) {
        if (!isInteger) {
          addError(i18next.t('common:form.error.integer'))
        }
        if (isGqlSafe(MAX_SAFE_GQL_INTEGER)) {
          addError(i18next.t('common:form.error.outOfRange'))
        }
      }

      break
    }
  }
}
